// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"8c4c26a615c204c98568","293":"ef3277c2bf653b40bf4f","518":"9249eeaabde30113b44a","779":"4f37fbfe0a7cdfb431fd"}[chunkId] + ".js";
};